export default __webpack_public_path__ + "assets/ico_play-08605927.svg";